---
title: 'Hotfix during code freeze'
metaTitle: 'Admin-UI Docs | Guides > Hotfix during code freeze'
---

A few times during the year we need to do a code freeze and block deployments of the admin-ui in production and hipaa environments. Even with the few code freeze we sometimes have to deploy a hotfix. Follow this guide to deploy a fix in production.

## 1. Create the release branch

`release/*` branches are protected, so you cannot create one manually. You need to dispatch the [Create Release Branch workflow](https://github.com/coveo-platform/admin-ui/actions/workflows/create-release-branch.yml).

1.  Open the link to the workflow
2.  Click on run workflow
3.  Enter the version currently running in production in the `tag to start from` input. Each app has its own tags, named `<app>@<version>` (e.g., `platform@12.2019.0` or `commerce-hub@12.1550.0`): use the tag of the app you need to fix. To identify the version running in production you can look at the source code of the page on [https://platform.cloud.coveo.com/admin](https://platform.cloud.coveo.com/admin/). ![Production version](./images/hotfix-get-version.png)
4.  The workflow will run and create the branch

## 2. Create your pull request

Instead of basing your changes on master you need to start from the branch created at step 1. It will be named something like `release/platform@12.2019.0`.

Code your changes and open a pull request. Make sure to target the release branch and not `master`. Like `master`, the release branch requires an approved pull request.

A push to the release branch runs the CD Dispatcher workflow as it exists on that branch. If the tag you started from predates the move to `release/*` branches, its `.github/workflows/cd-dispatcher.yml` still only runs on `master` and `hotfix-**`, so merging your fix alone will not deploy anything. In that case, also copy into your pull request the `release/**` branch filter and the `deploy_outside_business_hours` condition from `cd-dispatcher.yml` on `master`.

## 3. Make sure the deployment goes to production

The CD pipeline will run for the release branch. Once everything is validated, it will start a deployment for the new version (e.g., `platform@12.2019.1`).

The dev tooling team added a certifier that will always fail in staging during code freezes. You'll need to get someone from QA, R&D Defence, or Ops to override the approval and then restart the certifier for the deployment to continue to production and hipaa.

![Certifier](./images/hotfix-certifier-override.png)

## 4. Bring the fix in master

Don't forget to also apply your fix in master, otherwise there will be a regression once the code freeze is lifted.
